import "./ew-mi-gallery";
import "./ew-mi-gallery-slider";
